// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/move_project_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/move_project_image.proto.
 */
export const file_vision_assets_v1_move_project_image: GenFile = /*@__PURE__*/
  fileDesc("Cil2aXNpb24vYXNzZXRzL3YxL21vdmVfcHJvamVjdF9pbWFnZS5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEipwEKF01vdmVQcm9qZWN0SW1hZ2VSZXF1ZXN0EkcKBnBhcmFtcxgBIAEoCzI3LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLk1vdmVQcm9qZWN0SW1hZ2VSZXF1ZXN0LlBhcmFtcxpDCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIQCghpbWFnZV9pZBgCIAEoCRITCgtsb2NhdGlvbl9pZBgDIAEoCSJuChhNb3ZlUHJvamVjdEltYWdlUmVzcG9uc2USSAoGcmVzdWx0GAEgASgLMjgucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuTW92ZVByb2plY3RJbWFnZVJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.assets.v1.MoveProjectImageRequest
 */
export type MoveProjectImageRequest = Message<"protos.vision.assets.v1.MoveProjectImageRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.MoveProjectImageRequest.Params params = 1;
   */
  params?: MoveProjectImageRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.MoveProjectImageRequest.
 * Use `create(MoveProjectImageRequestSchema)` to create a new message.
 */
export const MoveProjectImageRequestSchema: GenMessage<MoveProjectImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_move_project_image, 0);

/**
 * @generated from message protos.vision.assets.v1.MoveProjectImageRequest.Params
 */
export type MoveProjectImageRequest_Params = Message<"protos.vision.assets.v1.MoveProjectImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string location_id = 3;
   */
  locationId: string;
};

/**
 * Describes the message protos.vision.assets.v1.MoveProjectImageRequest.Params.
 * Use `create(MoveProjectImageRequest_ParamsSchema)` to create a new message.
 */
export const MoveProjectImageRequest_ParamsSchema: GenMessage<MoveProjectImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_move_project_image, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.MoveProjectImageResponse
 */
export type MoveProjectImageResponse = Message<"protos.vision.assets.v1.MoveProjectImageResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.MoveProjectImageResponse.Result result = 1;
   */
  result?: MoveProjectImageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.MoveProjectImageResponse.
 * Use `create(MoveProjectImageResponseSchema)` to create a new message.
 */
export const MoveProjectImageResponseSchema: GenMessage<MoveProjectImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_move_project_image, 1);

/**
 * @generated from message protos.vision.assets.v1.MoveProjectImageResponse.Result
 */
export type MoveProjectImageResponse_Result = Message<"protos.vision.assets.v1.MoveProjectImageResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.MoveProjectImageResponse.Result.
 * Use `create(MoveProjectImageResponse_ResultSchema)` to create a new message.
 */
export const MoveProjectImageResponse_ResultSchema: GenMessage<MoveProjectImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_move_project_image, 1, 0);

